import { Dispatch, SetStateAction } from 'react';

import { useAudioControls } from '@/hooks/emotion-detector';

import GuideInfoDisplay from './components/GuideInfoDisplay';
import Transport from './components/Transport';
import { AudioPlayerWrapper, Background, Container, InvisibleSpacer, Wrapper } from './styles';
import { CurrentAudio } from './types';

interface AudioPlayerProps {
	currentAudio: CurrentAudio;
	setCurrentAudio: Dispatch<SetStateAction<CurrentAudio>>;
}

export default function AudioPlayer({ currentAudio, setCurrentAudio }: AudioPlayerProps) {
	const isVisible = !!currentAudio.element;
	const { handlePlayPause, handleBack15, handleForward15, handleStop, handleSeek } = useAudioControls({
		currentAudio,
		setCurrentAudio,
	});

	return (
		<AudioPlayerWrapper>
			<Wrapper isVisible={isVisible}>
				<Background />
				<Container>
					<GuideInfoDisplay currentAudio={currentAudio} />

					<Transport
						currentAudio={currentAudio}
						onPlayPause={handlePlayPause}
						onBack15={handleBack15}
						onForward15={handleForward15}
						onStop={handleStop}
						onSeek={handleSeek}
					/>

					<InvisibleSpacer />
				</Container>
			</Wrapper>
		</AudioPlayerWrapper>
	);
}
